import { CACHE_TTL } from './JucyCacheConstants.js';
export class JucyCache {
    config;
    constructor(config) {
        this.config = config;
    }
    getKey(key) {
        return `${this.config.service.replace(/-/g, '_')}/${key.replace(/-/g, '_')}`;
    }
    async get(key, generator, ttl = CACHE_TTL.FIVE_MIN) {
        let result = await this.config.store.get(this.getKey(key));
        if ((!result || (Array.isArray(result) && result.length === 0)) && generator) {
            result = await generator();
            await this.set(key, result, ttl);
        }
        return result || undefined;
    }
    async set(key, data, ttl) {
        await this.config.store.set(this.getKey(key), data, ttl);
    }
    async delete(key) {
        await this.config.store.delete(this.getKey(key));
    }
    async ttl(key) {
        return await this.config.store.ttl(this.getKey(key));
    }
}
